export const SIDE_PANEL_BANNER_HEIGHT_PROPERTY = '--side-panel-banner-height';
